import api from './api';

const importacaoService = {

  criar: async (dados) => {
    try {
      const response = await api.post('/importacoes', dados);
      return response.data;
    } catch (error) {
      throw error.response?.data || 'Erro ao criar importação';
    }
  },

  atualizar: async (id, dados) => {
    try {
      const response = await api.put(`/importacoes/${id}`, dados);
      return response.data;
    } catch (error) {
      throw error.response?.data || 'Erro ao atualizar importação';
    }
  },

  registrarPagamento: async (importacaoId, dados) => {
    try {
      const response = await api.post(`/importacoes/${importacaoId}/pagamentos`, dados);
      return response.data;
    } catch (error) {
      throw error.response?.data || 'Erro ao registrar pagamento';
    }
  },

  registrarDesembaraco: async (id, dados) => {
    try {
      const response = await api.put(`/importacoes/${id}/desembaraco`, dados);
      return response.data;
    } catch (error) {
      throw error.response?.data || 'Erro ao registrar desembaraço';
    }
  },

  obter: async (id) => {
    try {
      const response = await api.get(`/importacoes/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || 'Erro ao obter importação';
    }
  },

  listar: async (page = 0, size = 20) => {
    try {
      const response = await api.get('/importacoes', {
        params: { page, size, sort: 'dataImportacao,desc' },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || 'Erro ao listar importações';
    }
  },

  listarPorStatus: async (status) => {
    try {
      const response = await api.get(`/importacoes/status/${status}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || 'Erro ao listar importações por status';
    }
  },

  deletar: async (id) => {
    try {
      await api.delete(`/importacoes/${id}`);
    } catch (error) {
      throw error.response?.data || 'Erro ao deletar importação';
    }
  },

  obterEstatisticas: async () => {
    try {
      const response = await api.get('/importacoes/estatisticas/resumo');
      return response.data;
    } catch (error) {
      throw error.response?.data || 'Erro ao obter estatísticas';
    }
  },

  deletarPagamento: async (importacaoId, pagamentoId) => {
    try {
      const response = await api.delete(`/importacoes/${importacaoId}/pagamentos/${pagamentoId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || new Error('Erro ao deletar pagamento');
    }
  },

  liquidar: async (id) => {
    try {
      const response = await api.patch(`/importacoes/${id}/liquidar`);
      return response.data;
    } catch (error) {
      throw error.response?.data || 'Erro ao liquidar operação';
    }
  },

};

export default importacaoService;
